import {
  Box, Button, Grid, Stack, Typography,
} from '@mui/material';
import useActiveUserConfig from '../../../../sections/ActiveUserConfig/useActiveUserConfig';
import { InfoChip } from '../../../../components/CustomChip';
import { SelectBox, Switch } from '../../../../components/FormComponents';
import useStyles from '../../../../hooks/useStyles';
import styles from '../../../../layouts/pages/style';

function ActiveUserConfigCard() {
  const {
    filteredFeatures,
    enableSave,
    config,
    selectedKpi,
    handleSave,
    handleEnableConfig,
    handleFeatureChange,
  } = useActiveUserConfig();

  const classes = useStyles(styles)();

  return (
    <Box className={classes.cardStyles} sx={{ width: '100%' }}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography sx={{ fontSize: '22px', fontWeight: 500 }}>
          Active User
        </Typography>
        {enableSave && (
        <Button
          size="small"
          variant="outlined"
          onClick={handleSave}
        >
          Save
        </Button>
        )}
      </Stack>

      {/* Content */}
      <Grid container gap={2}>
        <Grid item container display="flex" justifyContent="space-between" alignItems="flex-end">
          <Grid item xs={8}>
            <InfoChip icon label="You can enable or disable Active-User config" />
          </Grid>

          <Grid item xs={3}>
            <Box justifySelf="flex-end">
              <Switch
                name="config"
                label="Enable Config"
                value={config}
                onChange={handleEnableConfig}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item container display="flex" justifyContent="space-between" alignItems="flex-end">
          <Grid item xs={8}>
            <Typography>Feature</Typography>
            <Typography fontSize="small">Select the feature used for analysis and calculations in active user configuration.</Typography>
          </Grid>

          <Grid item xs={3}>
            <SelectBox
              disabled={!config}
              name="selectedKpi"
              title="Feature"
              onChange={handleFeatureChange}
              data={filteredFeatures}
              value={selectedKpi}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default ActiveUserConfigCard;
